import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, GameAction} from '@colonist/game-base-types'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonViewWithBadge} from './UIGameActionButtonViewWithBadge'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {UIGameActionButtonPositions} from './UIGameActionsController'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import {MechanicValidatorCity} from '@colonist/game-mechanic-validators'
import {ActionState, CardEnum, MechanicCityState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameActionButtonViewCity extends UIGameActionButtonViewWithBadge {
    private readonly cityValidator: MechanicValidatorCity

    constructor(uiGameManager: UIGameManager, cityState: MechanicCityState, container: PIXI.Container) {
        const texture = UIGameSpriteHandler.getCityForPlayer(uiGameManager.gameController.myColor)
        const cityValidator = new MechanicValidatorCity(uiGameManager.gameController.getPlayerValidators(), uiGameManager.gameController.mapValidator, cityState)
        const bankCityAmount = cityValidator.getCityPlayerState(uiGameManager.gameController.myColor).bankCityAmount
        super(uiGameManager, UIGameActionButtonPositions.City, container, bankCityAmount)
        this.addCenteredIcon(texture)
        this.cityValidator = cityValidator

        this.setUpdateAction()
        this.stateUpdated()
        const cardsToBuildCity = [CardEnum.Grain, CardEnum.Grain, CardEnum.Ore, CardEnum.Ore, CardEnum.Ore]
        this.setHoverAction(cardsToBuildCity)
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        super.buttonSpecificEvents(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.CardAnimationEnd: this.setUpdateAction(); break
            case UIGameEventEnums.GivePlayerCardFromTile: this.onGivePlayerCardFromTile(); break
            case UIGameEventEnums.BeginnerModeInteractWithGuide: this.onBeginnerModeInteractWithGuide(data); break
            default: break
        }
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedCityButton()
        })
    }

    private clickedCityButton() {
        if(this.cancelBuild()) return
        if(!this.canPerformBuyAction(this.cityValidator.canPlayerPlaceCity(this.myPlayer.color))) return
        this.uiGameManager.socketGameSend.buildCity()
    }

    protected playerStateUpdated() {
        const cityPlayerState = this.cityValidator.getCityPlayerState(this.uiGameManager.gameController.myColor)
        this.updateBadgeCount(cityPlayerState.bankCityAmount)
    }

    protected stateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.cityValidator.canPlayerPlaceCity(this.myPlayer.color).canTakeAction) return

        this.updateOpacityForTurnState()
        this.updateHighlightForActionState()
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private updateHighlightForActionState() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceCity) return
        this.activateOpacity()
        this.highlight()
    }

    private cancelBuild(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceCity) return false

        this.uiGameManager.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight)
        this.uiGameManager.socketGameSend.cancelAction()
        return true
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        this.setShouldRevealButton(data, HiddenUIElement.CityActionButton, GameAction.ConfirmBuildCity)
    }

    protected onBeginnerModeInteractWithGuide(data: BeginnerModeActionState) {
        if(this.uiGameManager.gameController.currentState.actionState == ActionState.PlaceCity) return
        super.onBeginnerModeInteractWithGuide(data, GameAction.ConfirmBuildCity)
    }
}
